export default {
    name: 'B1',
    lineHeight: '48px',
    lineHeightDesktop: '48px',
  }